module.exports = __webpack_public_path__ + "static/media/dm.ba19acca.svg";